import { isObject, fill } from 'lodash';
export function moblieNumberMasking(mobile_number) {
    let tel = mobile_number.split('');
    return fill(tel, '*', 3, tel.length - 4).join('');
}

export default function getUserDisplayInfo(user) {
    if (isObject(user)) {
        let mobile_number = user.mobile_number ? moblieNumberMasking(user.mobile_number) : '';
        return user.nickname || user.email || mobile_number;
    }
    return '';
}

/**
 * 在有昵称的情况下获取额外的信息
 * @param {*} user 
 * @returns 
 */
export function getUserAdditionalDisplayInfo(user) {
    if (isObject(user) && user.nickname) {
        let mobile_number = user.mobile_number ? moblieNumberMasking(user.mobile_number) : '';
        return user.email || mobile_number;
    }
    return '';
}

/**
 * 排除昵称的情况下获取额外的信息
 * @param {*} user 
 * @returns 
 */
export function getAdditionalDisplayWithoutNickname(user) {
    if (isObject(user)) {
        let mobile_number = user.mobile_number ? moblieNumberMasking(user.mobile_number) : '';
        return user.email || mobile_number || user.name;
    }
    return '';
}
